import { parse, parseISO, format } from "date-fns";

export const splitHostName = (hostname) => {
  var result = {};
  if (hostname === "localhost") {
    result.domain = hostname;
    return result;
  } else {
    var regexParse = new RegExp("([a-z-0-9]{2,63}).([a-z.]{2,5})$");
    var urlParts = regexParse.exec(hostname);
    result.domain = urlParts[1];
    result.type = urlParts[2];
    result.subdomain = hostname
      .replace(result.domain + "." + result.type, "")
      .slice(0, -1);
    return result;
  }
};

export const fromDbToDisplay = (retrievedData) => {
  delete retrievedData.id;
  delete retrievedData.__typename;

  try {
    const formattedDate = format(
      parseISO(retrievedData.birthDate),
      "d/MM/yyyy",
    );
    const obj = { ...retrievedData, birthDate: formattedDate };
    const objKeys = Object.keys(obj);
    objKeys.forEach((key) => {
      if (obj[key] == null) {
        obj[key] = "";
      }
    });

    return obj;
  } catch (e) {
    const obj = { ...retrievedData };
    const objKeys = Object.keys(obj);
    objKeys.forEach((key) => {
      if (obj[key] == null) {
        obj[key] = "";
      }
    });
    return obj;
  }
};

export const fromDisplayToDb = (data) => {
  let parsedDate;
  try {
    parsedDate = format(
      parse(data.birthDate, "d/MM/yyyy", new Date()),
      "yyyy-MM-dd",
    );
  } catch (e) {
    parsedDate = null;
  }
  return { ...data, birthDate: parsedDate };
};

export const it = (number, index) => {
  return [
    ["poco fa", "fra poco"],
    ["%s secondi fa", "fra %s secondi"],
    ["un minuto fa", "fra un minuto"],
    ["%s minuti fa", "fra %s minuti"],
    ["un'ora fa", "fra un'ora"],
    ["%s ore fa", "fra %s ore"],
    ["un giorno fa", "fra un giorno"],
    ["%s giorni fa", "fra %s giorni"],
    ["una settimana fa", "fra una settimana"],
    ["%s settimane fa", "fra %s settimane"],
    ["un mese fa", "fra un mese"],
    ["%s mesi fa", "fra %s mesi"],
    ["un anno fa", "fra un anno"],
    ["%s anni fa", "fra %s anni"],
  ][index];
};

export const analyticTrack = async () => {
  const token = localStorage.getItem("client-token");
  const text = window.location.pathname;

  let response = await fetch(`/api/analytics`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: token ? `Bearer ${token}` : "",
    },
    body: JSON.stringify({ text }),
  });

  await response.text();
};

export const colorShade = (col, amt) => {
  col = col.replace(/^#/, "");
  if (col.length === 3)
    col = col[0] + col[0] + col[1] + col[1] + col[2] + col[2];

  let [r, g, b] = col.match(/.{2}/g);
  [r, g, b] = [
    parseInt(r, 16) + amt,
    parseInt(g, 16) + amt,
    parseInt(b, 16) + amt,
  ];

  r = Math.max(Math.min(255, r), 0).toString(16);
  g = Math.max(Math.min(255, g), 0).toString(16);
  b = Math.max(Math.min(255, b), 0).toString(16);

  const rr = (r.length < 2 ? "0" : "") + r;
  const gg = (g.length < 2 ? "0" : "") + g;
  const bb = (b.length < 2 ? "0" : "") + b;

  return `#${rr}${gg}${bb}`;
};
